import { render, staticRenderFns } from "./SurveyResponseBubble.vue?vue&type=template&id=c13d030a&scoped=true"
import script from "./SurveyResponseBubble.vue?vue&type=script&lang=js"
export * from "./SurveyResponseBubble.vue?vue&type=script&lang=js"
import style0 from "./SurveyResponseBubble.vue?vue&type=style&index=0&id=c13d030a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13d030a",
  null
  
)

export default component.exports